module.exports = __webpack_public_path__ + "img/C2M实验室2.0圆盘.2338c3e5.png";